"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AUS_States = void 0;
/* eslint-disable camelcase */
const AUS_States = exports.AUS_States = ['NSW', 'VIC', 'ACT', 'NT', 'QLD', 'SA', 'TAS', 'WA'];
var _default = exports.default = {
  AUS_States
};